(ns app.front.view.project.conditions
  (:require [app.domain.application.condition.model :as condition-model]
            [app.domain.group.config.model :as config-model]
            [app.front.entities :as entities]
            [app.front.ui.typography :refer [h2]]
            [app.front.util :as futil]
            [app.front.view.conditions.list :as conditions-list]
            [app.front.view.project.subs :as ps]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub]]
            [core.front.href :as href]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::project-phase-ids
  (ps/child-entity-sub-signal-fn ::ps/project-workspace-ids)
  (ps/child-entity-sub-fn [:entity.type/application :entity.type/execution]))

(rf/reg-sub ::project-condition-ids
  (ps/child-entity-sub-signal-fn ::project-phase-ids)
  (ps/child-entity-sub-fn :entity.type/application-condition))

(defn sort-and-index [conditions]
  (->> conditions
       (sort-by :ordered/order)
       (map-indexed vector)))

(rf/reg-sub ::conditions
  (fn [[_ project-id]]
    [(rf/subscribe [::entities/context])
     (rf/subscribe [::project-condition-ids project-id])])
  (fn [[ctx condition-ids] _]
    (->> condition-ids
         (entities/find-entities ctx)
         (group-by (comp :entity/parent :entity/parent))
         (p/map-vals (partial remove condition-model/general-condition?))
         (p/map-vals sort-and-index)
         ;; vals is tuple ix+condition - filter out cleared but keep count unchanged
         (p/map-vals (partial filter (comp (complement :application.condition/cleared)
                                           second)))
         ;; remove empties
         (filter (comp seq second))
         (into {}))))

(rf/reg-sub ::has-conditions?
  (fn [[_ project-id]]
    (rf/subscribe [::conditions project-id]))
  (fn [conds _]
    (-> conds seq boolean)))


(defn conditions-list [conds]
  (let [tr   (<sub [:tr])
        lang (<sub [:language])]
    [:<>
     (futil/for-all [[workspace conditions] conds]
       ^{:key (:db/id workspace)}
       [:div.first:mt-0.mt-12
        (cc/link {:href (href/href :view/workspace
                                   {:workspace-id (:workspace/id workspace)})}
                 [h2 (str (config-model/category-name workspace lang)
                          " (" (or (:workspace/municipal-case-id workspace)
                                   (:workspace/id workspace)) ")")])
        (futil/for-all [[idx condition] conditions]
          ^{:key (:db/id condition)}
          [conditions-list/condition-row
           condition
           idx
           (-> condition :entity/parent :db/id)
           false
           tr
           false])])]))
